import Upload from "../components/Upload"
import AdminLayout from "../components/AdminLayout"
import BulkUploadHeader from "../components/BulkUploadHeader"
import { Helmet } from "react-helmet-async"
import useAuth from "../hooks/useAuth"

const BulkUpload = () => {
  const { auth } = useAuth()

  return (
    <AdminLayout page="applicants/upload" role={auth?.role}>
      <Helmet>
        <title>Applicant Management | Edge</title>
      </Helmet>

      <BulkUploadHeader page="bulk-upload" />
      <Upload />
    </AdminLayout>
  )
}

export default BulkUpload
